import {useState} from 'react';
import { color, Common } from '@stockbit/ui';
import { ManagementProps, managements, ManagementPropsFunction } from '../constants';
import { AboutContainer, Title } from '../styled';
import { Card, ManagementContainer, Modal } from './styled';

const { Text } = Common;

const Person = ({ name, position, desc, showDesc }: ManagementPropsFunction) => (
  <>
    <Text as="p" family="bold" size={showDesc ? "30px" : "22px"} mt="4px" mb="4px">
      {name}
    </Text>
    <Text
      as="p"
      family="bold"
      size={showDesc ? "20px" : "16px"}
      mt="4px"
      color={color.suvaGrey}
    >
      {position}
    </Text>
    { showDesc && <Text as="p" size="18px" mt="24px" align="justify">
      {desc}
    </Text>}
  </>
);

const Management = () => {

  const defaultModalData = {
    name: '',
    position: '',
    desc: '',
  };
  const [showModalManagement, setShowModalManagement] = useState<boolean>(false);
  const [modalData, setModalData] = useState<ManagementProps>(defaultModalData);

  const showModal = (management: ManagementProps) => {
    toggleModal(true);
    setModalData(management)
  }

  const toggleModal = (params: boolean) => {
    setShowModalManagement(params)
  }

  const closeModal = () => {
    toggleModal(false);
    setModalData(defaultModalData)
  }

  return (
  <AboutContainer>
    <Title align="center" mb="60px">Manajemen</Title>
    <ManagementContainer>
      {managements.slice(0, 2).map((management) => (
        <Card active={management.name === modalData.name} onClick={() => showModal(management)}>
          <Person key={management.name} {...management} showDesc={false} />
        </Card>
      ))}
    </ManagementContainer>
    <ManagementContainer>
      {managements.slice(2, 6).map((management) => (
        <Card active={management.name === modalData.name} onClick={() => showModal(management)}>
          <Person key={management.name} {...management} showDesc={false} />
        </Card>
      ))}
    </ManagementContainer>
    <Modal 
      visible={showModalManagement}
      onCancel={closeModal}
      centered
      width={700}
    >
      <Person {...modalData} showDesc={true} />
    </Modal>
  </AboutContainer>
)};

export default Management;
